<style scoped>
  .project-number{color: #333333;font-size: 14px;margin-left: 40px;display: inline-block;}
  .btn-default{font-size: 14px;color: #00a2e9;display: inline-block;vertical-align:middle}
  .list-panel{background-color: white;padding:0 40px}
  .list-title{color: #464c5b;font-size: 16px;font-weight: bold;}
  .list-schedule{color: #626c70;font-size: 14px;}
  .list-host-text{font-size: 14px;color: #626c70;display: inline-block;margin-right: 19px;vertical-align: text-top;}
  .list-host-avatar{width: 30px;height: 30px;border-radius: 15px;margin-right: 10px;}
  .notice-background{background: url("/img/sys/bg8.png");height: 140px;}
  .list-pending{color:#626c70;font-size: 14px;display: inline-block;vertical-align: text-top;margin-top: 4px;}
  .search >>> .ivu-input{width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
</style>

<template>
  <div>
    <Modal v-model="detailsPanel.state" title="归档详情">
      <template v-if="detailsPanel.state">
        <Row>
          <Col span="8" style="text-align: right">案件名称：</Col>
          <Col span="16">{{detailsPanel.info.CaseTitle}}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align: right">案件分类：</Col>
          <Col span="16">{{typeList.project[detailsPanel.info.CaseTypeId]}}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align: right">案件类型：</Col>
          <Col span="16">{{detailsPanel.info.CaseClassTitle}}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align: right">归档时间：</Col>
          <Col span="16">{{detailsPanel.info.RecordTime}}</Col>
        </Row>
        <Row>
          <Col span="8" v-if="detailsPanel.info.manager" style="text-align: right">主办律师：</Col>
          <Col span="16"><template v-for="(item,index) in detailsPanel.info.manager"><template v-if="index>0&&index<detailsPanel.info.manager.length">、</template>{{item.name}}</template></Col>
        </Row>
      </template>
    </Modal>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <!--添加-筛选-->
    <Row style="background-color: #fcfcfc;line-height:80px;">
      <Col span="22">
        <div class="project-number">
          <div style="display: inline-block;padding-right: 10px;">共有<span style="color: #00a2e9;font-size: 24px;">{{search.total}}</span>个归档项目</div>
          <div style="border-right: 1px solid #e3e3e3;display: inline-block;height: 40px;vertical-align: middle;line-height: 100px;"></div>
        </div>
      </Col>
    </Row>
    <!--列表面板-->
    <div class="list-panel">
      <Row justify="center" v-for="(item,index) in list">
          <Col span="24" style="height: 134px;border-bottom: 1px solid #d7dde4;display: flex;align-items: center;">
          <Col span="14" style="line-height: 38px;">
            <router-link :to="{name:'projectTask',query:{caseId:item.CaseId,taskId:item.taskId,filed:1}}">
              <span>
                <p class="list-title">{{item.CaseTitle}}</p>
                <p class="list-schedule">
                  归档日期： | {{item.RecordTime}}
                </p>
              </span>
            </router-link>
          </Col>
          <Col span="5">
            <p class="list-host-text">主办</p>
            <Avatar class="list-host-avatar" v-if="i.name" v-for="i in item.manager">{{i.name[0]}}</Avatar>
          </Col>
          <Col span="5">
            <p class="list-pending"><Button v-if="item.RecordId" type="warning" @click="deleteArchives(item.RecordId)">删除归档</Button></p>
          </Col>
        </Col>
      </Row>
      <Row>
        <Col span="24" style="margin:40px 0 57px 0;">
          <Page
              :show-sizer="true"
              :show-total="true"
              @on-page-size-change="search.pageSize=$event;caseList()"
              :total="search.total"
              :page-size="search.pageSize"
              :page-size-opts="[5,10,15]"
              show-elevator
              @on-change="search.page = $event;caseList()"
          />
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "list",
    data () {
      return {
        detailsPanel:{
          state:false,
          info:{},
        },
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          type:'',//案件类型
          text:'',//搜索文字
          completed:'',//0/1
        },
        list : [],//案件列表
        typeList:{
          project:{},
          case:{},
        },
      }
    },
    methods:{
      deleteArchives:function(id){
        var _this = this
        _this.send({
          headers:'RC/DeleteRecord',
          data:{
            RecordId:id,
          },
          confirm:true,
          success:function (res) {
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除成功！',
            })
            _this.caseList()
          }
        })
      },
      caseList : function () {
        var _this = this
        _this.list = []
        _this.send({
          headers: "RC/RecordList",
          data: {
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            SearchWord:_this.search.text,
            CaseTypeId:_this.search.type,
          },
          warning:function(res){
            if(res.data.Code==504){
              _this.$Notice.error({
                title:'系统提示',
                desc:'无相关数据！'
              })
              _this.$router.push({name:'archivesSearch'})
            }
          },
          success : function (res) {
            for(var index in res.List){
              var tempArr = []
              for(var secIndex in res.List[index].Executors){
                tempArr.push({
                  name:res.List[index].Executors[secIndex].UserName,
                  id:res.List[index].Executors[secIndex].UserId,
                })
              }
              res.List[index].manager = tempArr
            }
            _this.list = res.List
            _this.search.total = res.Count
          }
        })
      },
      getTypeList : function () {
        var _this = this
        _this.typeList = []
        _this.send({
          headers: "C/CaseTypeList",
          success : function (res) {
            _this.typeList.project = {}
            _this.typeList.case = {}
            for(var index in res.TypeList){
              _this.typeList.project[res.TypeList[index].CaseTypeId] = res.TypeList[index].CaseTypeTitle
            }
            for(var index in res.ClassList){
              _this.typeList.case[res.ClassList[index].CaseClassId] = res.ClassList[index].CaseClassTitle
            }
          }
        })
      },
    },
    mounted : function () {
      this.search.text=this.$route.query.text
      this.search.type=this.$route.query.type
      this.caseList()
      this.getTypeList()
    }
  }
</script>

<style scoped>

</style>
